module.exports = __webpack_public_path__ + "img/Arrow-Rotate.d6fe8627.svg";